// Shared cart logic: header counter + "add to cart" buttons in product lists.
// Buttons: <button type="button" data-add-to-cart data-variant-id="123">...</button>
(function () {
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function setCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      el.textContent = count > 99 ? '99+' : count;
      el.classList.toggle('hidden', !count);
    });
    document.querySelectorAll('[data-cart-float]').forEach((el) => el.classList.toggle('hidden', !count));
  }

  function refreshCount() {
    return fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } })
      .then((response) => response.json())
      .then((cart) => {
        setCount(cart.item_count);
        return cart;
      })
      .catch((error) => console.error('Cart count error:', error));
  }

  let toastTimer;
  function showToast(message, isError) {
    let toast = document.getElementById('essential-cart-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'essential-cart-toast';
      toast.setAttribute('role', 'status');
      toast.style.cssText =
        'position:fixed;left:50%;bottom:24px;transform:translateX(-50%);z-index:9999;max-width:90vw;padding:12px 20px;color:#fff;font-size:16px;text-align:center;transition:opacity .2s;';
      document.body.appendChild(toast);
    }
    toast.textContent = message;
    toast.style.background = isError ? '#b91c1c' : '#234427';
    toast.style.opacity = '1';
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => {
      toast.style.opacity = '0';
    }, 3000);
  }

  function addToCart(button) {
    const variantId = Number(button.dataset.variantId);
    if (!variantId || button.disabled) return;

    const originalHtml = button.innerHTML;
    button.disabled = true;

    fetch(`${root}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: Number(button.dataset.quantity) || 1 }] }),
    })
      .then((response) =>
        response.json().then((data) => {
          if (!response.ok) throw new Error(data.description || data.message || 'Error');
          return data;
        })
      )
      .then(() => {
        button.textContent = button.dataset.addedText || '✓';
        showToast(button.dataset.addedMessage || '✓');
        setTimeout(() => {
          button.innerHTML = originalHtml;
          button.disabled = false;
        }, 1500);
        return refreshCount();
      })
      .catch((error) => {
        console.error('Error adding product to cart:', error);
        showToast(error.message, true);
        button.disabled = false;
      });
  }

  // Delegated, so it also works for slides cloned by Swiper loop mode
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-add-to-cart]');
    if (!button) return;
    event.preventDefault();
    addToCart(button);
  });

  document.addEventListener('cart:updated', refreshCount);
  window.addEventListener('pageshow', (event) => {
    // Page restored from back/forward cache may show a stale count
    if (event.persisted) refreshCount();
  });

  window.EssentialCart = { refreshCount, setCount, addToCart, showToast };
})();
